import React from 'react';
import useSelector from 'components/Booking-new/hooks';
import stepTypes from 'components/Booking-new/modules/Steps/types';

const WaitlistDataContainer = (Component, { data }) => {
  const {
    results: { locationData, serviceData, waitlistFailureLink, waitlistSuccessLink },
  } = useSelector(state => {
    const stepTimeData = state?.allSteps?.find(item => item?.type === stepTypes.time);
    const stepLocationData = state?.allSteps?.find(item => item?.type === stepTypes.location);

    return {
      locationData: state?.userData[stepTypes.location]?.selectedLocation,
      serviceData: state?.config?.service,
      waitlistSuccessLink:
        stepTimeData?.data?.waitlistSuccessLink || stepLocationData?.data?.waitlistSuccessLinkLT || '/',
      waitlistFailureLink: stepTimeData?.data?.waitlistFailureLink || '/',
    };
  });

  const waitlistProps = {
    locationHeading: locationData?.heading,
    locationCode: locationData?.code,
    serviceName: serviceData?.name,
    waitlistSuccessLink,
    waitlistFailureLink,
    data,
  };
  return <Component {...waitlistProps} />;
};

export default WaitlistDataContainer;
